import { API, graphqlOperation } from 'aws-amplify'
import * as queries from '@/graphql/queries'
import * as publicQueries from '@/graphql/publicQueries'
import * as mutations from '@/graphql/mutations'

export default {
  async fetchVacancies() {
    const response = await API.graphql(graphqlOperation(queries.listVacancies))
    return response.data.listVacancies.items
  },
  async fetchPublicVacancies() {
    const response = await API.graphql({
      query: publicQueries.listPublicVacancies,
      authMode: 'API_KEY',
      variables: {
        filter: {
          hidden: {
            eq: false,
          },
        },
      },
    })
    return response.data.listVacancies.items
  },
  async createVacancy(vacancy) {
    const response = await API.graphql(
      graphqlOperation(mutations.createVacancy, {
        input: vacancy,
      })
    )
    return response.data.createVacancy
  },
  async updateVacancy(vacancy) {
    const response = await API.graphql(
      graphqlOperation(mutations.updateVacancy, {
        input: vacancy,
      })
    )
    return response.data.updateVacancy
  },
  async deleteVacancy(vacancyId) {
    const response = await API.graphql(
      graphqlOperation(mutations.deleteVacancy, {
        input: {
          id: vacancyId,
        },
      })
    )
    return response
  },
}
